import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2, KeyRound } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPass.length < 6) {
      toast.error('New password must be at least 6 characters');
      return;
    }
    if (newPass !== confirm) {
      toast.error('New passwords do not match');
      return;
    }
    setSaving(true);
    try {
      const res = await fetch(`${API}/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ current_password: current, new_password: newPass })
      });
      const data = await res.json();
      if (res.ok) {
        toast.success('Password changed successfully');
        setCurrent(''); setNewPass(''); setConfirm('');
        onOpenChange(false);
      } else {
        toast.error(typeof data.detail === 'string' ? data.detail : 'Could not change password');
      }
    } catch {
      toast.error('Connection error. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog" className="bg-white">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-[#0B0B0B]" style={{ fontFamily: 'Clash Display' }}>
            Change Password
          </DialogTitle>
          <DialogDescription>Enter your current password, then choose a new one.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="current-pass">Current Password</Label>
            <Input id="current-pass" type="password" data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} required className="mt-1" />
          </div>
          <div>
            <Label htmlFor="new-pass">New Password</Label>
            <Input id="new-pass" type="password" data-testid="new-password-input" value={newPass} onChange={(e) => setNewPass(e.target.value)} required className="mt-1" placeholder="At least 6 characters" />
          </div>
          <div>
            <Label htmlFor="confirm-pass">Confirm New Password</Label>
            <Input id="confirm-pass" type="password" data-testid="confirm-new-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1" />
          </div>
          <Button type="submit" data-testid="change-password-submit-btn" disabled={saving} className="w-full bg-[#0B0B0B] text-white hover:bg-[#2a2a2a] rounded-full py-6 font-bold">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><KeyRound className="w-4 h-4 mr-2" /> Update Password</>}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
